import {exists, isDomElement} from "./wvn_exist";

var map = {
  geofield : function (elementHtmlTag) {
    /* CATCH the point(s) */
    // if field--single
    var data = [
      [elementHtmlTag.querySelector('.latlon-lat').innerHTML, elementHtmlTag.querySelector('.latlon-lon').innerHTML],
    ];
    if (typeof data[0] == 'undefined') {

      return;
    }
    /* CATCH the point(s) */

    /* CREATE the map container */
    var mapContainerId = 'map-container';
    elementHtmlTag.classList.forEach(function (className) {
      if (/^field--name-[A-Za-z\-]+$/.test(className)) {
        mapContainerId += '--' + className.replace(/^field--name-([\w\-]+)$/, '$1');
      }
    });
    elementHtmlTag.id += mapContainerId;
    _leafletPrivate.map.setMapContainerId(mapContainerId);
    /* CREATE the map container */

    _leafletPrivate.map.set();

    _leafletPrivate.map.tile.set('openStreetMap');

    data.forEach(function (point, i) {
      var icon = _leafletPrivate.marker.icon.get(i, i == 0 && data.length > 1);

      _leafletPrivate.marker.add(i,[point[0], point[1]], icon);
    });

    _leafletPrivate.marker.center();
  }
};

var _leafletPrivate = {
  map : {
    object : null,
    id : '',
    minZoom : 7,
    zoom : 8,
    set : function () {
      if (
        !exists(_leafletPrivate.map.id)
        || !isDomElement(document.getElementById(_leafletPrivate.map.id))
      ) {
        return;
      }

      _leafletPrivate.map.object = L.map(
        _leafletPrivate.map.id,
        {
          minZoom: _leafletPrivate.map.minZoom,
          scrollWheelZoom: false
        }
      );
    },
    center : function (activeIndex) {
      _leafletPrivate.marker.activeIndex = activeIndex;
      var center = _leafletPrivate.marker.markers[activeIndex].getLatLng();
      _leafletPrivate.map.object.setView(center);
    },
    tile : {
      openStreetMap : {
        url : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        options : {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          subdomains: ['a','b','c']
        }
      },
      set : function (tileName) {
        if (_leafletPrivate.map.object === null) {
          return;
        }

        L.tileLayer(
          _leafletPrivate.map.tile[tileName].url,
          _leafletPrivate.map.tile[tileName].options
        ).addTo(_leafletPrivate.map.object);
      },
    },
    setMapContainerId : function (id) {
      _leafletPrivate.map.id = id;
    },
  },
  marker : {
    activeIndex : 0,
    markers : [],
    add : function (slideNo, point, icon) {
      _leafletPrivate.marker.markers[slideNo] = L.marker(
        point,
        {icon: icon}
      ).addTo(_leafletPrivate.map.object);
    },
    center : function () {
      if (_leafletPrivate.map.object === null) {
        return;
      }

      var group = new L.featureGroup(_leafletPrivate.marker.markers);

      _leafletPrivate.map.object.fitBounds(group.getBounds(),{padding: [10, 30]})
    },
    icon : {
      src : '/themes/custom/horeca_theme/images/marker.svg',
      className : 'marker-center',
      get : function (slideNo, isActive) {
        return new L.divIcon({
          iconSize: [50, 60],
          iconAnchor: [25, 30],
          popupAnchor: [0, 0],
          className: _leafletPrivate.marker.icon.className + ' ' + (isActive ? 'marker-active' : 'marker-inactive'),
          // html: '<button data-slide="' + slideNo + '"><img alt="marker" src="' + _leafletPrivate.marker.icon.src + '" /></button>'
          html: '<img alt="marker" src="' + _leafletPrivate.marker.icon.src + '" />'
        });
      },
      set : function (sliderNo, isActive) {
        var icon = _leafletPrivate.marker.icon.get(sliderNo, isActive);
        _leafletPrivate.marker.markers[sliderNo].setIcon(icon);
      },
    },
  },
};

export default map;
